
import { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
    
    try {
      const consent = localStorage.getItem('cookie-consent');
      if (!consent) {
        setIsVisible(true);
      }
    } catch (error) {
      console.log('LocalStorage error:', error);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem('cookie-consent', 'accepted');
    } catch (error) {
      console.log('LocalStorage error:', error);
    }
    setIsVisible(false);
  };

  const handleDecline = () => {
    try {
      localStorage.setItem('cookie-consent', 'declined');
    } catch (error) {
      console.log('LocalStorage error:', error);
    }
    setIsVisible(false);
  };

  if (!isLoaded || !isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-[#B97A72] p-4 sm:p-6 z-40">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1">
          <h4 className="text-lg font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            Cookies et confidentialité
          </h4>
          <p className="text-sm text-[#6B5E5A]" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
            En continuant à naviguer, vous acceptez notre utilisation des cookies.
          </p>
        </div>
        
        <div className="flex gap-3 w-full sm:w-auto">
          <button
            onClick={handleDecline}
            className="flex-1 sm:flex-none px-4 py-2 border-2 border-[#B97A72] text-[#B97A72] rounded-lg hover:bg-[#F8EDEA] transition-colors cursor-pointer text-sm whitespace-nowrap"
            style={{ fontFamily: 'Poppins, sans-serif' }}
            type="button"
          >
            Refuser
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 sm:flex-none px-6 py-2 bg-[#B97A72] text-white rounded-lg hover:bg-[#C49B86] transition-colors cursor-pointer text-sm whitespace-nowrap"
            style={{ fontFamily: 'Poppins, sans-serif' }}
            type="button"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
